<style scoped="scoped">
@import '../../../../assets/css/common.css';
</style>
<style scoped="scoped">
  .mobileforgetpsw {
    color: #333333;
    font-family:"SourceHanSansCN-Regular";
    font-size: 12px;
  }

  .mobileforgetpsw .resetpwd_title{
    margin: 20px 0px;
    font-size:22px;
    letter-spacing: 2px;
    text-align: center;
    font-weight:600;
  }
  .mobileforgetpsw .resetpwd-content .resetpwd_form_wrapper{
    width: 90%;
    margin: 0 auto;
    text-align: center;
  }
  .mobileforgetpsw .resetpwd-content .resetpwd_form_wrapper .resetpwd_btn {
    color: #FFFEFE;
    background: rgba(16, 142, 233, 1);
    width: 100%;
    height: 40px;
    border-radius: 6px;
    margin-bottom: 22px;
  }
  .mobileforgetpsw .resetpwd-content  .sendcode {
    color:#108EE9!important;
    font-size:14px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    background: transparent;
    position: absolute;
    top: 7px;
    right: 10px;
    text-align: right;
  }
  .mobileforgetpsw .resetpwd-content .sendcode.is-disabled{
    color:#999999!important;
  }
  .mobileforgetpsw .resetpwd-content .image-code-item{
    position: relative;
  }
  .mobileforgetpsw .resetpwd-content .image-code-img{
    width: 120px;
    height: 34px;
    position: absolute;
    top: 3px;
    right: 10px;
    border-radius: 4px;
    cursor: pointer;
  }
</style>
<style type="text/css">
  .mobileforgetpsw .resetpwd-content  .el-form-item.is-success .el-input__inner,
  .mobileforgetpsw .resetpwd-content  .el-form-item.is-success .el-textarea__inner{
    border-color:#D6D6D6;
  }
  .mobileforgetpsw .resetpwd-content  .el-form-item .el-input__inner:focus,
  .mobileforgetpsw .resetpwd-content  .el-form-item .el-textarea__inner:focus{
    background:rgba(255,255,255,1);
    border:1px solid rgba(16,142,233,1);
    box-shadow:0px 0px 10px 0px rgba(16,142,233,0.3);
    border-radius:6px;
  }
  .mobileforgetpsw .el-input--prefix .el-input__inner{
    padding-left: 35px;
  }
  .mobileforgetpsw .validcode span.el-input__prefix{
    line-height:40px;
  }
  .mobileforgetpsw .el-form-item{
    margin-bottom:20px;
  }
</style>
<template>
  <div class="mobileforgetpsw">
    <header class="mobilehead">
      <el-row>
        <el-col :span="4"><div style="padding-left:8px" @click="clickLogin"><img src="../../../../assets/images/icon/back.png" /></div></el-col>
        <el-col :span="16"><div class="tlc">重置密码</div></el-col>
        <el-col :span="4"><div></div></el-col>
      </el-row>
    </header>
    <div class="resetpwd-content">
      <div class="resetpwd_title">重置密码</div>
      <div class="resetpwd_form_wrapper">
        <el-form :model="resetpwdForm" status-icon ref="resetpwdForm" :rules="rules" class="resetpwdform">
          <el-form-item label="" prop="mobile">
            <el-input v-model.trim="resetpwdForm.mobile" autocomplete="off" placeholder="手机号" max="20" clearable>
              <i slot="prefix" class="el-input__icon icon-my-user"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="imageCode" class="image-code-item">
            <el-input v-model.trim="resetpwdForm.imageCode" autocomplete="off" placeholder="图形验证码" :maxlength="10" class="validcode" clearable>
              <i slot="prefix" class="el-input__icon icon-my-validcode"></i>
            </el-input>
            <img class="image-code-img" :src="imageCodeSrc" @click="refreshImageCode">
          </el-form-item>
          <el-form-item label="" class="pstv">
            <el-input v-model.trim="resetpwdForm.smsCode" autocomplete="off" placeholder="验证码" :maxlength="8" class="validcode">
              <i slot="prefix" class="el-input__icon icon-my-validcode"></i>
            </el-input>
            <el-button class="sendcode" @click="sendCode" :disabled="!show" type="text">{{ showCount }}</el-button>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input type="password" v-model.trim="resetpwdForm.newPassword" autocomplete="off" placeholder="新密码" max="100" clearable>
              <i slot="prefix" class="el-input__icon icon-my-password"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="confirmPassword">
            <el-input type="password" v-model.trim="resetpwdForm.confirmPassword" autocomplete="off" placeholder="确认密码" max="100" clearable>
              <i slot="prefix" class="el-input__icon icon-my-password"></i>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button class="resetpwd_btn" @click="submitForm('resetpwdForm')" @keyup.enter.native="submitForm('resetpwdForm')">提交</el-button>
      </div>
    </div>
    <div id="toTop" class="toTop" v-show="isShow" @click="toTop()"></div>
  </div>
</template>

<script>
import smsImageCodeMixin from '@/mixins/smsImageCodeMixin'
import commonService from '@/service/commonService'
export default {
  name: 'mobileforgetpsw',
  mixins: [smsImageCodeMixin],
  data: function () {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      }
      if (value && (value.replace(/^\s+|\s+$/gm, '').length < 6 || value.replace(/^\s+|\s+$/gm, '').length > 18)) {
        callback(new Error('密码长度为6-18位'))
      }
      if (value !== this.resetpwdForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      isShow: false,
      resetpwdForm: {
        mobile: '',
        imageCode: '',
        smsCode: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请输入登录手机号码', trigger: 'blur' },
          { validator: this.$rules.phoneNumber, trigger: 'blur' }
        ],
        imageCode: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' }
        ],
        newPassword: [{ required: true, message: '请输入正确密码', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请输入正确密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    clickLogin () {
      this.pagedefault = ''
      this.$router.push({name: 'fronthome'})
      this.$nextTick(() => {
        this.pagedefault = '/'
      })
    },
    async sendCode () {
      await this.sendSmsCodeWithImage()
    },
    submitForm (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.$cookie.set('token', this.SysConstant.basicAuth)
          this.$cookie.set('deviceId', this.resetpwdForm.mobile)
          try {
            await commonService.resetFrontPassword(this.resetpwdForm)
            this.$alert('密码重置成功,是否返回到登录页', '', {type: 'success', customClass: 'mobileconfirm'}).then(() => {
              this.$router.push({name: 'mobileLogin'})
            })
          } catch (e) {
            this.$message.error({
              message: e && e.msg,
              customClass: 'errmsg'
            })
          }
        } else {
          this.$message.error({
            message: '提交失败',
            customClass: 'errmsg'
          })
          return false
        }
      })
    },
    forgetPwd () {
      this.$router.push({name: 'mobileForgetpsw'})
    },
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.isShow = scrollTop > 300
    },
    toTop () {
      let distanceY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.interval = setInterval(() => {
        if (distanceY - 60 > 0) {
          distanceY -= 60
          window.scrollTo(0, distanceY)
        } else {
          window.scrollTo(0, 0)
          clearInterval(this.interval)
        }
      }, 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/front/mobile-page/forgetpsw/index.vue